import { QueryFunctionContext } from 'react-query';
import { SECOND_API } from '../api';

export function getStreaks({ signal }: QueryFunctionContext) {
    return SECOND_API.get(SECOND_API.PATH.getStreak, { signal }).then((res) => res.data);
}

export function updateStreak(data: any) {
    return SECOND_API.put(SECOND_API.PATH.updateStreak, data).then((res) => res.data);
}
